import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/perfis/actions';

import Form from './form';

function Perfis() {
  const redux = useSelector((state) => state.perfis);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = useMemo(
    () => [
      {
        id: 'nomeperfil',
        label: t('s.cadastro..usuario.perfil.nomeperfil'),
        filter: { type: 'text' },
      },
      {
        id: 'statusperfil',
        label: t('s.cadastro..usuario.perfil.statusperfil'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  const fieldlist = ['nomeperfil', 'statusperfil'];

  const substituirHeader = {
    nomeperfil: t('s.cadastro..usuario.perfil.nomeperfil'),
    statusperfil: t('s.cadastro..usuario.perfil.statusperfil'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idperfil"
      detach="idperfil"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'perfis',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Perfis',
          substituirValores: {
            statusperfil: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default Perfis;
